import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { cars } from "../../data/cars";
import { Language } from "../../types";
import { useContextProvider } from "../../context";
import { Menu } from "../menu";
import { carcDict, getCarUrl } from "../../utilities";
import { CarDetails } from "../shared/carDetails";
import "./index.css";
import { BookingForm } from "./bookingForm";

const dict = {
  [Language.English]: {
    backButton: "Go back",
  },
  [Language.Spanish]: {
    backButton: "Volver",
  },
  [Language.Russian]: {
    backButton: "Назад",
  },
  [Language.Ukrainian]: {
    backButton: "Назад",
  },
};

export const Car: React.FC = () => {
  const { language } = useContextProvider();
  const { id } = useParams();
  const navigate = useNavigate();
  const car = cars.find((car) => getCarUrl(car) === id);

  useEffect(() => {
    if (!car) {
      navigate("/");
    }
    window.scrollTo(0, 0);
  }, [car]);

  if (!car) {
    return null;
  }

  return (
    <div className="Car">
      <Menu />
      <div className="Car-container">
        <CarDetails car={car} language={language} withPadding={true} />

        <div className="Car-extraInfo">
          <div className="Car-extraInfo-item">
            {carcDict[language].dailyKmIncluded} {car.dailyKmIncluded}
          </div>
          <div className="Car-extraInfo-item">
            {carcDict[language].additionalKmPrice} {car.additionalKmPrice} €
          </div>
          <div className="Car-extraInfo-item">
            {carcDict[language].deposit} {car.deposit} €
          </div>
        </div>

        <div className="Car-props">
          <div className="Car-props-title">
            <strong>{carcDict[language].props}</strong>
          </div>
          <div className="Car-props-list">
            {car.props.map((prop) => (
              <div className="Car-props-item" key={prop}>
                {carcDict[language].propsList[prop]}
              </div>
            ))}
          </div>
        </div>

        <BookingForm car={car} />

        <button className="Car-backButton" onClick={() => navigate(-1)}>
          {dict[language].backButton}
        </button>
      </div>
    </div>
  );
};
